import Icon from '../components/Icon.vue'

Icon.register({
  'angle-down': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M143 352.3L7 216.3C-2.4 206.9-2.4 191.7 7 182.4L29.6 159.8C39 150.4 54.2 150.4 63.5 159.8L159.9 256.2 256.3 159.8C265.7 150.4 280.9 150.4 290.2 159.8L312.8 182.4C322.2 191.8 322.2 207 312.8 216.3L176.8 352.3C167.6 361.7 152.4 361.7 143 352.3z'
      }
    ]
  }
})
